






















import inputMixin from 'library/mixins/input-mixin'
export default

	mixins: [ inputMixin ]

	props:

		# Type of textfield
		type:
			type: String
			default: 'textarea'

		name:
			type: String
			default: ''

		placeholder:
			type: String
			default: ''

		inverted:
			type: Boolean
			default: false

		noPill:
			type: Boolean
			default: false

		minlength:
			type: String
			default: '0'

		maxlength:
			type: String
			default: '524288' # The default for textareas

	computed:
		classes: -> [
			'inverted' if @inverted
			'no-pill' if @noPill
		]

